import request from '../../utils/request'


//获取体检系统安装包列表
export function getZipFileList(): Promise<any> {
  return request({
    method: 'GET',
    url: 'manage/download/zipFileList',
  })
}

